// PeptideVault v6.5 — Settings tab

// ══════════════════════════════════════════════════════
// RENDER: SETTINGS TAB
// ══════════════════════════════════════════════════════
function renderSettingsTab() {
  const mode = S.settings.syncMode || 'auto'
  const modes = [
    { id:'auto',   label:'iCloud Drive (Auto)',  desc:'Automatically syncs to ~/iCloud Drive/PeptideVault — accessible on all your devices' },
    { id:'custom', label:'Custom Folder',         desc:'Choose any folder on your Mac or external drive' },
    { id:'local',  label:'Local Only',            desc:'Saves to ~/PeptideVault — no sync, stays on this machine' },
  ]
  return `
  <div style="animation:fadeIn .25s ease;max-width:600px">
    <h2 style="font-size:20px;font-weight:700;margin-bottom:20px">Settings</h2>

    <!-- User Profiles -->
    <div class="card" style="margin-bottom:16px">
      <div class="card-header">
        <div class="card-title">${ICONS.user} User Profiles</div>
        <button class="btn btn-secondary btn-sm" onclick="openModal('addUser')">${ICONS.plus} Add User</button>
      </div>
      <div class="card-body" style="gap:8px">
        ${(S.users||[]).map(u => `
        <div class="row" style="gap:10px;padding:8px;border-radius:var(--r2);background:var(--bg3)">
          <div style="width:32px;height:32px;border-radius:50%;background:${u.color};color:white;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0">${esc(u.initials||u.name.slice(0,2).toUpperCase())}</div>
          <div style="flex:1">
            <div style="font-size:13px;font-weight:600">${esc(u.name)}</div>
            ${u.notes ? `<div style="font-size:11px;color:var(--text3)">${esc(u.notes)}</div>` : ''}
          </div>
          <span class="badge ${u.active?'badge-green':'badge-gray'}">${u.active?'Active':'Inactive'}</span>
          <button class="btn btn-ghost btn-xs" onclick="openModal('editUser',{userId:'${u.id}'})">${ICONS.edit}</button>
        </div>`).join('')}
      </div>
    </div>

    <!-- Sync / Storage mode -->
    <div class="card" style="margin-bottom:16px">
      <div class="card-header"><div class="card-title">Data Sync &amp; Storage</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:12px">

        <!-- Mode selector tiles -->
        <div style="display:flex;flex-direction:column;gap:8px">
          ${modes.map(m => `
          <label style="display:flex;align-items:flex-start;gap:12px;padding:12px 14px;border:2px solid ${mode===m.id?'var(--blue)':'var(--border)'};border-radius:var(--r2);background:${mode===m.id?'var(--blueL)':'var(--bg3)'};cursor:pointer;transition:all .15s" onclick="setSettingMode('${m.id}')">
            <input type="radio" name="syncMode" value="${m.id}" ${mode===m.id?'checked':''} style="margin-top:2px;accent-color:var(--blue)">
            <div>
              <div style="font-size:13px;font-weight:600;color:${mode===m.id?'var(--blue)':'var(--text)'}">${m.label}</div>
              <div style="font-size:12px;color:var(--text3);margin-top:2px">${m.desc}</div>
            </div>
          </label>`).join('')}
        </div>

        <!-- Custom folder picker (shown only in custom mode) -->
        ${mode === 'custom' ? `
        <div style="background:var(--bg4);border-radius:var(--r2);padding:12px 14px;display:flex;flex-direction:column;gap:8px">
          <div class="form-label">Custom Folder Path</div>
          <div class="row" style="gap:8px">
            <div class="form-input" style="flex:1;font-family:var(--mono);font-size:12px;color:var(--text2);word-break:break-all;min-height:36px;display:flex;align-items:center">${esc(S.settings.customDir || 'No folder selected')}</div>
            <button class="btn btn-secondary btn-sm" onclick="browseCustomFolder()">Browse…</button>
          </div>
          ${S.settings.customDir ? `<div style="font-size:11px;color:var(--greenT)">✓ Folder configured</div>` : `<div style="font-size:11px;color:var(--yellowT)">⚠ Please select a folder</div>`}
        </div>` : ''}

        <!-- Active data directory display -->
        <div>
          <div class="form-label">Active Data Directory</div>
          <div class="form-input" style="background:var(--bg3);color:var(--text3);font-family:var(--mono);font-size:11px;word-break:break-all">${esc(dataDir || '(not yet initialised)')}</div>
          <div style="font-size:11px;color:var(--text4);margin-top:4px">Your data file and documents folder live here. Settings are saved separately at ~/.peptide-vault-settings.json so they survive app updates.</div>
        </div>

        ${isElectron ? `
        <div class="row" style="margin-top:4px">
          <button class="btn btn-secondary btn-sm" onclick="exportData()">${ICONS.export} Export Backup</button>
          <button class="btn btn-secondary btn-sm" onclick="importData()">Import Backup</button>
        </div>` : ''}
        <div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border2)">
          <div style="font-size:12px;font-weight:600;margin-bottom:4px">Fix Triple-Import Transactions</div>
          <div style="font-size:11px;color:var(--text4);margin-bottom:8px">If a storage import ran multiple times and inflated stock totals, this removes the "Imported into…" transactions and their offsetting bulk removals, restoring SKU stock to its pre-import values. Real scan/manual history is kept.</div>
          <button class="btn btn-danger btn-sm" onclick="appConfirm('Remove all import-created transactions and their offsets, then recompute stock? This cannot be undone — back up first.',()=>{cleanupImportTransactions(true)})">Clean Up Import Transactions</button>
        </div>
      </div>
    </div>

    <!-- Export / Print -->
    <div class="card" style="margin-bottom:16px">
      <div class="card-header"><div class="card-title">Export &amp; Print</div></div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:10px">
        <div style="font-size:13px;color:var(--text3)">Export your full inventory or print a formatted report.</div>
        <div class="row">
          <button class="btn btn-secondary btn-sm" onclick="exportCSV()">${ICONS.export} Export CSV</button>
          <button class="btn btn-secondary btn-sm" onclick="exportJSON()">Export JSON</button>
          <button class="btn btn-secondary btn-sm" onclick="printReport()">${ICONS.print} Print Report</button>
        </div>
      </div>
    </div>

    <!-- App info -->
    <div class="card" style="margin-bottom:16px">
      <div class="card-header"><div class="card-title">App Info</div></div>
      <div class="card-body">
        <div class="detail-grid">
          <div class="detail-item"><div class="detail-label">Version</div><div class="detail-value">${typeof APP_VERSION !== "undefined" ? APP_VERSION : "6.5.0"}</div></div>
          <div class="detail-item"><div class="detail-label">Peptides</div><div class="detail-value">${S.peptides.length}</div></div>
          <div class="detail-item"><div class="detail-label">Documents</div><div class="detail-value">${S.documents.length}</div></div>
          <div class="detail-item"><div class="detail-label">Platform</div><div class="detail-value">${isElectron?'Desktop':'Browser'}</div></div>
        </div>
      </div>
    </div>

    <!-- Cloud Sync -->
    <div class="card" style="margin-bottom:16px">
      <div class="card-header">
        <div class="card-title">☁️ Cloud Sync</div>
        <span class="badge ${S.settings.cloudToken?'badge-green':'badge-gray'}">${S.settings.cloudToken?'Connected':'Not configured'}</span>
      </div>
      <div class="card-body" style="display:flex;flex-direction:column;gap:12px">
        <div style="font-size:13px;color:var(--text2)">
          Connect to Cloudflare D1 to sync data automatically with your iPhone PWA and other devices.
        </div>
        <div class="form-group">
          <label class="form-label">API URL</label>
          <input class="form-input" id="f-cloud-url" placeholder="https://peptide-vault.pages.dev/api/data"
            value="${esc(S.settings.cloudUrl||'')}">
        </div>
        <div class="form-group">
          <label class="form-label">Sync Token</label>
          <input class="form-input" id="f-cloud-token" type="password"
            placeholder="Your sync token…" style="font-family:var(--mono)"
            value="${esc(S.settings.cloudToken||'')}">
        </div>
        <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap">
          <label style="font-size:13px;display:flex;align-items:center;gap:6px;cursor:pointer">
            <input type="checkbox" id="f-autosync" ${S.settings.autoSyncEnabled?'checked':''}
              onchange="S.settings.autoSyncEnabled=this.checked; saveCloudSettings()">
            Auto-sync on focus
          </label>
          <label style="font-size:13px;display:flex;align-items:center;gap:6px">
            Background pull every
            <input type="number" id="f-autosync-interval" min="0" max="60" step="1" style="width:56px;text-align:center"
              class="form-input" value="${S.settings.autoSyncIntervalMin||0}">
            min <span style="font-size:11px;color:var(--text4)">(0 = off)</span>
          </label>
        </div>
        <div class="row" style="flex-wrap:wrap;gap:8px">
          <button class="btn btn-primary btn-sm" onclick="saveCloudSettings()">Save Cloud Settings</button>
          ${S.settings.cloudToken ? `
          <button class="btn btn-secondary btn-sm" onclick="syncFromCloud()">↓ Pull from Cloud</button>
          <button class="btn btn-secondary btn-sm" onclick="syncToCloud()">↑ Push to Cloud</button>
          <button class="btn btn-secondary btn-sm" onclick="restoreThisDeviceFromCloud()">↺ Restore This Device from Cloud</button>
          <button class="btn btn-ghost btn-sm" style="color:var(--red)" onclick="clearCloudSettings()">Disconnect</button>
          ` : ''}
        </div>
        ${S.settings.cloudToken ? `
        <div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border2)">
          <div style="font-size:12px;font-weight:600;margin-bottom:4px">Recover Health Data from Backup</div>
          <div style="font-size:11px;color:var(--text4);margin-bottom:8px">If health data was trimmed, this restores it from the full cloud backup (the whole-blob backup, which piece-sync doesn't overwrite). Only restores arrays larger in the backup than locally — won't shrink anything.</div>
          <button class="btn btn-secondary btn-sm" onclick="recoverFromWholeBlob()">↺ Recover from Full Backup</button>
        </div>
        ` : ''}
        <div style="margin-top:10px;padding-top:10px;border-top:1px solid var(--border2)">
          <div style="font-size:12px;font-weight:600;margin-bottom:4px">Local Safety Backups</div>
          <div style="font-size:11px;color:var(--text4);margin-bottom:8px">Automatic timestamped snapshots are kept on this device (before every pull and clear, and at startup). The 10 most recent are retained. You can also take one now or restore the latest.</div>
          <div class="row" style="gap:8px;flex-wrap:wrap">
            <button class="btn btn-secondary btn-sm" onclick="manualBackupNow()">💾 Backup Now</button>
            <button class="btn btn-secondary btn-sm" onclick="restoreLatestBackup()">↩︎ Restore Latest Backup</button>
          </div>
        </div>
        ${(() => {
          const { rows, total, maxChunk } = storageSizeBreakdown()
          const totalKB = (total/1024).toFixed(0)
          const maxKB = (maxChunk/1024).toFixed(0)
          const tooBig = maxChunk > 900000
          return `
          <div style="margin-top:14px;padding-top:14px;border-top:1px solid var(--border2)">
            <div class="row" style="margin-bottom:8px">
              <div style="font-size:13px;font-weight:600">Sync Data Size</div>
              <div class="spacer"></div>
              <span class="badge ${tooBig?'badge-red':'badge-green'}">${totalKB} KB total · ${maxKB} KB largest chunk</span>
            </div>
            ${tooBig ? `<div style="font-size:12px;color:var(--red);margin-bottom:8px;line-height:1.5">⚠ Largest single chunk is near the ~1 MB D1 row limit. Trim the biggest items below.</div>` : ''}
            <div style="font-size:12px;display:flex;flex-direction:column;gap:3px">
              ${rows.slice(0,5).map(r => `<div style="display:flex;justify-content:space-between"><span style="color:var(--text3)">${esc(r.key)} <span style="color:var(--text4)">(${r.count})</span></span><span style="font-weight:600">${(r.bytes/1024).toFixed(0)} KB</span></div>`).join('')}
            </div>
            <button class="btn btn-secondary btn-sm" style="margin-top:10px" onclick="openModal('syncHealth')">View Details & Trim</button>
          </div>`
        })()}
      </div>
    </div>

    <!-- AI Configuration (Items 2-7) -->
    <div class="card">
      <div class="card-header"><div class="card-title">AI Integration</div></div>
      <div class="card-body">
        ${(() => {
          const cfg = typeof getAIConfigurationStatus === 'function' ? getAIConfigurationStatus() : { available: false, platform: 'pwa', showKeyField: false, provider: 'Anthropic', transport: 'Unknown', statusLabel: 'Not configured' }
          return `
            <div style="display:grid;grid-template-columns:auto 1fr;gap:4px 12px;font-size:13px;margin-bottom:12px">
              <span style="color:var(--text3)">Provider</span><span style="font-weight:600">${cfg.provider}</span>
              <span style="color:var(--text3)">Transport</span><span>${cfg.transport}</span>
              <span style="color:var(--text3)">Status</span><span style="color:${cfg.available?'var(--green)':'var(--red)'}; font-weight:600">${cfg.statusLabel}</span>
            </div>
            ${cfg.showKeyField ? `
              <div class="form-group" style="margin-bottom:8px">
                <label class="form-label">API Key</label>
                <div class="row" style="gap:8px">
                  <input class="form-input" id="settings-ai-key" type="password" placeholder="sk-ant-..." style="flex:1;font-family:var(--mono);font-size:12px" value="">
                  <button class="btn btn-primary btn-sm" onclick="if(typeof setAnthropicCredential==='function'){setAnthropicCredential(document.getElementById('settings-ai-key').value);showToast('Key saved');render()}else{saveAnthropicKeyFromSettings()}">Save</button>
                </div>
              </div>` : `
              <div style="font-size:12px;color:var(--text3);margin-bottom:8px">AI credentials managed by ${cfg.transport}. No API key entry needed.</div>`}
            <div class="row" style="gap:8px;margin-bottom:12px">
              <button class="btn btn-secondary btn-sm" onclick="testAnthropicConnection()">Test Connection</button>${cfg.platform==='pwa' ? '<button class="btn btn-ghost btn-sm" onclick="refreshPwaAIHealth().then(function(){render()})">Refresh AI Status</button>' : ''}
              <div id="ai-test-result" style="font-size:12px;line-height:28px"></div>
            </div>`
        })()}
        <div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin:12px 0 6px">AI Data Access Controls</div>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:6px">
          ${['peptides','inventory','protocols','health','labs','ice','notes','documents'].map(d => `<label style="display:flex;align-items:center;gap:6px;font-size:12px;cursor:pointer">
            <input type="checkbox" ${S._aiPrivacy[d] !== false ? 'checked' : ''} onchange="S._aiPrivacy['${d}']=this.checked;if(typeof saveSettings==='function')saveSettings()"> ${d.charAt(0).toUpperCase()+d.slice(1)}
          </label>`).join('')}
        </div>
      </div>
    </div>

    <!-- Density Mode (BN48) -->
    <div class="card">
      <div class="card-header"><div class="card-title">Display Density</div></div>
      <div class="card-body">
        <div style="display:flex;gap:8px">
          <button class="btn btn-sm ${(S._densityMode||'comfortable')==='comfortable'?'btn-primary':'btn-secondary'}" onclick="setDensityMode('comfortable')">Comfortable</button>
          <button class="btn btn-sm ${S._densityMode==='compact'?'btn-primary':'btn-secondary'}" onclick="setDensityMode('compact')">Compact</button>
        </div>
        <div style="font-size:11px;color:var(--text4);margin-top:6px">Compact reduces padding and font sizes for denser information display.</div>
      </div>
    </div>

    <!-- Danger zone -->
    <div class="card" style="border-color:var(--redL)">
      <div class="card-header"><div class="card-title" style="color:var(--red)">Danger Zone</div></div>
      <div class="card-body">
        <button class="btn btn-danger btn-sm" onclick="clearAllData()">Clear All Data</button>
        <div style="font-size:12px;color:var(--text4);margin-top:6px">Permanently deletes all peptides and documents. Cannot be undone.</div>
      </div>
    </div>
  </div>`
}

export {
  renderSettingsTab
}
